import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import { Box, ButtonBase } from '@mui/material';

import QRFullLogo from '~/assets/icons/sidebar-logo-new.svg?react';
import PhonesImage from '~/assets/images/payments/phones.png';
import { Text } from '~/components/ui/text';
import { PATH } from '~/constants/route-path';

import * as S from './styles';

export function UpgradeContent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <Box sx={S.upgradeContainer}>
      <Box sx={S.upgradeHead}>
        <QRFullLogo width={130} height={30} />
        <Text variant="input15" sx={{ color: 'var(--grey400)' }}>
          {t('upgradeModal:logoText')}
        </Text>
      </Box>
      <Text variant="h2">{t('upgradeModal:title')}</Text>
      <Text variant="input15" sx={{ color: 'var(--grey400)', margin: '8px 0' }}>
        {t('upgradeModal:subTitle')}
      </Text>
      <img className="upgrade-img" src={PhonesImage} alt="phones image" />
      {[...Array(8)].map((_, index) => (
        <Box sx={S.listItem} key={t(`upgradeModal:listItem${index + 1}`)}>
          <CheckIcon sx={{ color: 'var(--primary)', maxWidth: '18px' }} />
          <Text variant="input15" sx={{ color: 'var(--grey400)' }}>
            {t(`payments:list:a${index + 1}`)}
          </Text>
        </Box>
      ))}
      <ButtonBase sx={S.upgradeButton} onClick={() => navigate(PATH.PAYMENTS.MAIN)}>
        {t('upgradeModal:buttonText')}
      </ButtonBase>
    </Box>
  );
}
